import React from "react";
import './style.css';
import Logo from '../../asset/img/logo/Save-Logo-White.png';

const Navbar = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg fixed-top">
        <div className="container py-2">
          <a className="navbar-brand pe-2" href="/">
            <img src={Logo}
              alt="Logo"
              className="d-inline-block align-text-top"
              style={{width: 'auto', height: 40}}/>
          </a>
          <button
            className="navbar-toggler light"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto ps-2 fs-5">
              <li className="nav-item">
                <a className="nav-link text-white" href="/">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-white" href='#pricing'>Pricing</a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-white" href='#contact'>Contact</a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-white" href='/save-doc'>Documentation</a>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link text-white" href={`${process.env.PUBLIC_URL}/blog`}>Blog</a>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;